import Schedule from "@material-ui/icons/Schedule";
import React, { useState } from "react";
import { injectIntl, WrappedComponentProps } from "react-intl";
import { GetTranslation } from "../../translations/GetTranslation";
import CustomSplitButton from "../common/buttons/CustomSplitButton";

type SchedulerOpenButtonProps = {
  onScheduleOralExams: () => void;
  scheduleOralExamsAvailable: boolean;
  onScheduleWrittenExams: () => void;
  scheduleWrittenExamsAvailable: boolean;
  onScheduleCorrectionExams: () => void;
  scheduleCorrectionExamsAvailable: boolean;
} & WrappedComponentProps;

const SchedulerOpenButton: React.FunctionComponent<SchedulerOpenButtonProps> = ({
  onScheduleOralExams,
  scheduleOralExamsAvailable,
  onScheduleWrittenExams,
  scheduleWrittenExamsAvailable,
  onScheduleCorrectionExams,
  scheduleCorrectionExamsAvailable,
  intl,
}) => {
  const scheduleOptions = new Array<{ label: string; handler: () => void }>();
  if (scheduleOralExamsAvailable) {
    scheduleOptions.push({ label: GetTranslation(intl, "common.scheduleOralExams"), handler: onScheduleOralExams });
  }
  if (scheduleWrittenExamsAvailable) {
    scheduleOptions.push({
      label: GetTranslation(intl, "common.scheduleWrittenExams"),
      handler: onScheduleWrittenExams,
    });
  }
  if (scheduleCorrectionExamsAvailable) {
    scheduleOptions.push({
      label: GetTranslation(intl, "common.scheduleCorrectionExams"),
      handler: onScheduleCorrectionExams,
    });
  }

  const [selectedMenuIndex, setSelectedMenuIndex] = useState(0);
  const [buttonTooltip, setButtonTooltip] = useState(scheduleOptions.length > 0 ? scheduleOptions[0].label : "");

  if (!scheduleOralExamsAvailable && !scheduleWrittenExamsAvailable && !scheduleCorrectionExamsAvailable) {
    return null;
  }

  const handleButtonClick = (index: number) => {
    if (index < scheduleOptions.length) {
      scheduleOptions[index].handler();
    }
  };

  const handleMenuItemClick = (_: React.MouseEvent<HTMLLIElement, MouseEvent>, index: number) => {
    if (index < scheduleOptions.length) {
      setButtonTooltip(scheduleOptions[index].label);
      setSelectedMenuIndex(index);
      handleButtonClick(index);
    }
  };

  const options = scheduleOptions.map((option) => option.label);

  return (
    <CustomSplitButton
      tooltip={buttonTooltip}
      onClick={() => handleButtonClick(selectedMenuIndex)}
      options={options}
      onMenuItemClick={handleMenuItemClick}
    >
      <Schedule />
    </CustomSplitButton>
  );
};

export default injectIntl(SchedulerOpenButton);
